<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col flex-auto">
      <legend class="usa-legend usa-legend--large">@if (businessTypeChecked) {
        <span>HHG </span>
      }Document Management</legend>
    </div>
    @if (isSysAdmin && businessTypeChecked) {
      <div class="grid-col flex-auto margin-left-2">
        <ul class="usa-nav__primary usa-accordion">
          <li class="usa-nav__primary-item">
            <button class="usa-accordion__button define-eclipse" aria-expanded="false" aria-controls="more-actions"
              data-tooltip="Click for more options">
              <span>&hellip;</span>
            </button>
            <ul id="more-actions" class="usa-nav__submenu" hidden>
              <li class="usa-nav__submenu-item">
                <a (click)="gotoReport()" routerLink="/documentmanagementreport">Document Management
                Report</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    }
  </div>
  @if (!isCarrierUser && !businessTypeChecked) {
    <form [formGroup]="chooseBusinessType">
      <div class="grid-row">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="businessType" class="usa-label">Business Type</label>
          <select id="businessType" formControlName="businessType" class="usa-select width-full" title="businessType"
            name="businessType"
            (change)="onBusinessTypeSelect($event.target.value)">
            <option [value]='null' selected disabled>Choose...</option>
            @for (c of businessTypeList; track c) {
              <option [value]="c">{{c}}</option>
            }
          </select>
        </div>
      </div>
    </form>
  }
  @if (businessTypeChecked || isCarrierUser) {
    <div class="usa-accordion margin-top-4">
      <h4 class="usa-accordion__heading">
        <button
          type="button"
          class="usa-accordion__button"
          aria-expanded="true"
          aria-controls="a1"
          >
          Upload Document
        </button>
      </h4>
      <div id="a1" class="usa-accordion__content usa-prose">
        <form [formGroup]="documentManagementForm">
          <div class="grid-row grid-gap">
            @if (isSysAdmin) {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="agent-scac" class="usa-label">SCAC Code<abbr title="required"
                class="usa-hint usa-hint--required">*</abbr></label>
                <input type="text" placeholder="Enter SCAC code" id="agent-scac" class="usa-input maxw-full"
                  formControlName='scacList' [typeahead]="typeaheadlist" [typeaheadMinLength]="minLengthToSearch"
                  [typeaheadOptionsLimit]="10" [maxlength]="maxCharLength">
              </div>
            }
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="documentType" class="usa-label">Document Type<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
              <select id="documentType" formControlName="documentType" class="usa-select maxw-full" title="documentType"
                name="documentType" (change)="onDocumentType($event)">
                <option [value]='null' selected disabled>Choose...</option>
                @for (c of documentTypeList; track c) {
                  <option [value]="c">{{c}}</option>
                }
              </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
              <label class="usa-label">Effective Date<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="effectiveDate" formControlName="effectiveDate" class="maxw-full usa-input"
                [value]="this.defaultDate" bsDatepicker/>
              <div class="usa-checkbox margin-top-2">
                <input class="usa-checkbox__input" id="noEffDate" type="checkbox" [checked]="checkNoEffDate"
                  (change)="onCheckNoEffDate($event)"/>
                <label class="usa-checkbox__label" for="noEffDate">No Effective Date</label>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
              <div>
                <label class="usa-label">Expiry Date<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              </div>
              <input type="text" id="expiryDate" formControlName="expiryDate" class="usa-input maxw-full"
                [value]="this.defaultDate"
                bsDatepicker/>
              <div class="usa-checkbox margin-top-2">
                <input class="usa-checkbox__input" id="noExpDate" type="checkbox" [checked]="checkNoExpDate"
                  (change)="onCheckNoExpDate($event)"/>
                <label class="usa-checkbox__label" for="noExpDate">No Expiry Date</label>
              </div>
            </div>
          </div>
          <div class="grid-gap grid-row">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="additionalComments1" class="usa-label">Additional Comments</label>
              <textarea id="additionalComments1" formControlName="additionalComments" maxLength="500"
              class="maxw-full usa-textarea"></textarea>
            </div>
          </div>
          <br>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
              <abbr title="required">Note: File types accepted: pdf or image (bmp, jpg, jpeg, png) with max size of 3GB</abbr>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <!--<div class="form-row col-md-4">-->
              <input type="file" class="topAndBottomMargins width-100" formControlName="filePicker" name="filePicker"
                id="filePicker" (change)="fInput($event);">
            <!-- </div>-->
          </div>
          @if (fileUpload.status==='error') {
            <div class="grid-row">
              <div class="usa-alert usa-alert--error usa-alert--slim">
                <div class="usa-alert__body">
                  <p class="usa-alert__text">
                    {{fileUpload.message}}
                  </p>
                </div>
              </div>
            </div>
          }
          @if (fileUpload.status==='done' && fileUpload.message) {
            <div class="grid-row">
              <div class="usa-alert usa-alert--success usa-alert--no-icon usa-alert--slim">
                <div class="usa-alert__body">
                  <p class="usa-alert__text">
                    {{fileUpload.message}}
                  </p>
                </div>
              </div>
            </div>
          }
          <br>
            <button type="button" class="usa-button" [disabled]="this.documentManagementForm.invalid" (click)="upload()">
              Save Document
            </button>
          </form>
        </div>
        <h4 class="usa-accordion__heading">
          <button
            type="button"
            class="usa-accordion__button"
            aria-expanded="false"
            aria-controls="a2"
            >
            Notify TSPs
          </button>
        </h4>
        <div id="a2" class="usa-accordion__content usa-prose">
          <form [formGroup]="tspNotificationForm">
            <br>
              <div class="grid-row grid-gap">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                  <label for="additionalComments" class="usa-label">Comments For TSP</label>
                  <textarea id="additionalComments" formControlName="tspComments" maxLength="500"
                  class="usa-textarea maxw-full"></textarea>
                </div>
              </div>
              <br>
                <button type="button" class="usa-button" (click)="upload()">Notify TSPs</button>
              </form>
            </div>
          </div>
        }
        <div class="grid-row grid-gap margin-top-4">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            @if (isCarrierUser) {
              <ag-grid-angular class="ag-theme-alpine" [gridOptions]="gridOptions" [animateRows]="true"
                [getDataPath]="getDataPath" [rowData]="documentManagementList" [icons]="icons"
                [components]="frameworkComponents" [autoGroupColumnDef]="autoGroupColumnDef"
                [enableRangeSelection]="true"
                (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
                [getRowId]="getRowId">
              </ag-grid-angular>
            }
            @if ((isSysAdmin && !isCarrierUser && businessTypeChecked)) {
              <ag-grid-angular class="ag-theme-alpine"
                [gridOptions]="documentManagementGridOptions" [animateRows]="true" [getDataPath]="getDataPath"
                [rowData]="documentManagementList" [icons]="icons" [components]="frameworkComponents"
                [autoGroupColumnDef]="autoGroupColumnDef" [enableRangeSelection]="true"
                (gridReady)="onGridReady1($event)"
                [detailCellRendererParams]="detailCellRendererParams"
                (rowClicked)="onRowClicked($event)" [getRowId]="getRowId">
              </ag-grid-angular>
            }
          </div>
        </div>
      </div>
